<script lang="ts" setup>
import { computed, inject } from 'vue'
import { DialogTitle } from '@headlessui/vue'
import LineX from '../../icons/LineX.vue'
import { DTModalHeaderInjector } from '../../keys'
import { classArray } from '../../utils/class'
import type { ComplexClassName } from '../../types/common'

const props = withDefaults(defineProps<{
  title?: string
  titleClass?: ComplexClassName
  useClose?: boolean
}>(), {
  useClose: true,
})

const modal = inject(DTModalHeaderInjector)

const titleClasses = computed(() => classArray(props.titleClass ?? '').concat(['font-semibold text-gray-800 mb-0 text-base']))
</script>

<template>
  <div class="relative flex min-h-[3.5rem] shrink-0 grow-0 items-center justify-center rounded-t-2xl border-b border-b-gray-200 p-4 md:px-6">
    <DTIconButton
      v-if="useClose"
      variant="plain"
      class="absolute left-4 top-3 !rounded-full text-gray-700"
      @click="modal?.close()"
    >
      <LineX class="w-5" />
    </DTIconButton>
    <slot>
      <DialogTitle
        v-if="title"
        :class="titleClasses"
      >
        {{ title }}
      </DialogTitle>
    </slot>
  </div>
</template>
